var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayCirclewhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 10)",
    stroke: "#FFF",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.5 36.3L33.3 25.8a3 3 0 00-4.5 2.6v21a3 3 0 004.5 2.6l18.2-10.5a3 3 0 000-5.2h0z",
    strokeWidth: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 4.2,
    cx: 39,
    cy: 39,
    r: 38.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCirclewhite);
export default __webpack_public_path__ + "static/media/Play Circle white.8ee91c2f20c8bd1acbb9647d60ac7364.svg";
export { ForwardRef as ReactComponent };